import React, { FunctionComponent } from 'react'
import styled from 'styled-components'
import { AutoImage } from './auto-image'
import { DesktopSnsIcons } from './desktop-sns-icons'

const Outer = styled.div`
  max-width: 100;
  display: flex;
`

const CanvasOuter = styled.div`
  flex: 0 0 80%;
  max-width: 64rem;
  position: relative;
  overflow: hidden;
  margin: 0 auto;
`

const CanvasInner = styled.div`
  margin: 8vw 3vw 3vw;
`

const CanvasBackground = styled.div`
  position: absolute;
  width: 106%;
  height: 100%;
  margin: 0 -3%;
  z-index: -1;
  img {
    width: 100%;
    height: auto;
  }
`

type DesktopHeadBannerProps = {

}
export const DesktopHeadBanner: FunctionComponent<DesktopHeadBannerProps> = ({children}) => {
  return <Outer>
    <CanvasOuter>
      <CanvasBackground>
        <AutoImage src='/images/note.jpg' width="2669" height="3493" />
      </CanvasBackground>
      <CanvasInner>
        {children}
      </CanvasInner>
    </CanvasOuter>
    <DesktopSnsIcons />
  </Outer>
}